export default __webpack_public_path__ + "static/media/knc.845b971a.svg";